export default "__VITE_ASSET__235d6235__"